/*
 * MTB-Raceshop – Termin-Datumsfelder (Einsende-Termin, Wunschtermin)
 * Gilt für alle Datumsfelder der Produktoptionen – auf der Produktseite und im Schnellkauf-Fenster.
 *
 * HIER EINSTELLEN – pro Feldname (= Beschriftung des Felds im Theme-Editor):
 *   vorlauf:   frühestes Datum = heute + so viele Tage
 *   maxTage:   spätestes Datum = heute + so viele Tage (0 = keine Grenze)
 *   ohneTage:  Wochentage ohne Annahme (0 = Sonntag, 1 = Montag … 3 = Mittwoch … 6 = Samstag)
 *   belegung:  true = ausgebuchte Tage aus dem Werkstatt-Kalender sperren
 *   kalender:  true = eigener Monatskalender statt Browser-Datumsfeld (volle und geschlossene Tage
 *              sind grau und durchgestrichen, freie Plätze werden nicht angezeigt).
 *              Das Browser-Feld bleibt unsichtbar und wird mitgeschickt.
 * Sonntage werden zusätzlich gesperrt, wenn im Theme-Editor «Exclude Sundays» aktiv ist.
 * Wie viele Federelemente pro Tag Platz haben, steht im Google-Skript «Werkstatt Kalender» (kapazitaet).
 *
 * Tuning-Artikel: main-product.liquid setzt am Feld data-werkstatt-varianten (Regel im Snippet
 * werkstatt-varianten.liquid):
 *   "alle"           = jede Variante braucht einen Termin
 *   "ohne:ID,ID,…"   = alle Varianten ausser diesen (z. B. «Einbau durch MTB-Raceshop: Nein»)
 *   "ID,ID,…"        = altes Format: nur diese Varianten brauchen einen Termin
 * Braucht die gewählte Variante keinen Termin, wird das Feld ausgeblendet und deaktiviert –
 * dann ist es kein Pflichtfeld und belegt keinen Werkstatt-Platz.
 *
 * Feldname: Der Name in der Bestellung bleibt in allen Sprachen deutsch (Einstellung «Feldname in der
 * Bestellung» am Block «Custom option» in main-product.liquid), damit FELDER, Flow und Kalender passen.
 * Texte: locales/*.json unter mrs.termin (übersetzbar mit Translate & Adapt), auf die Seite gebracht von
 * snippets/mrs-texte.liquid (window.mrsTexte). Fehlen sie, gelten die deutschen Texte unten.
 *
 * Anzeige «Nächster freier Service-Termin» (snippets/mrs-naechster-termin.liquid):
 * Elemente mit data-mrs-naechster-termin zeigen den nächsten freien Einsende-Termin für 1 Federelement,
 * mit denselben Regeln wie der Kalender (FELDER['Einsende-Termin'] und Belegung).
 *   "produkt" = Produktseite und Schnellkauf unter dem Preis. Die Zeile baut dieses Skript selbst ein (Block
 *               «Preis», .product-price), sobald das Produkt ein Feld «Einsende-Termin» hat. Sichtbar nur, wenn
 *               das Feld aktiv ist (bei Selbsteinbau also nicht). «Termin wählen» scrollt zum Kalender.
 *   "seite"   = z. B. Seite Fahrwerksservice (Block im Abschnitt «Rich text»). Seit 18.10.2026 zweizeilig:
 *               oben klein «● Nächster freier Service-Termin», darunter gross das Datum (zweizeilig()).
 *   "leiste"  = Ankündigungsleiste. Ohne Belegung bleibt der Ersatztext aus dem Theme stehen.
 * Ohne Belegung (Kalender nicht erreichbar) oder wenn alles ausgebucht ist, bleiben "produkt" und "seite" unsichtbar.
 * Die Belegung merkt sich der Browser 5 Minuten (sessionStorage), damit nicht jeder Seitenaufruf den Kalender abfragt.
 */
(function () {
  if (window.mtbTerminDatum) return;
  window.mtbTerminDatum = true;

  var FELDER = {
    // vorlauf 3 seit 01.11.2026 (David): Das Federelement muss spätestens am Werktag vor dem Einsende-Termin
    // bei uns sein (auch bei Montag-Terminen: Samstag), so bleibt nach der Buchung ein ganzer Tag zum Verschicken.
    'Einsende-Termin': { vorlauf: 3, maxTage: 56, ohneTage: [0, 3], belegung: true, kalender: true },
    'Wunschtermin':    { vorlauf: 3, maxTage: 180 }
  };
  var STANDARD = { vorlauf: 0, maxTage: 0 };

  // Web-App des Werkstatt-Kalenders (gleiche Adresse wie in Shopify Flow)
  var BELEGUNG_URL = 'https://script.google.com/macros/s/AKfycbx3pOkFDzfvi1qpc9vn50jC2mDkJsBxszB9vJNKJy3tOdZDUI8kcjSxW_8yYILOwOox/exec?aktion=belegung';
  var BELEGUNG_MAX_ALTER = 5 * 60 * 1000; // nach 5 Minuten neu abfragen
  var BELEGUNG_TIMEOUT = 8000;

  // Datumsfelder der Produktoptionen (Block «Custom option»). Bewusst ohne .custom-option: Im Schnellkauf-Fenster
  // fehlt dieser Rahmen (main-product.liquid übernimmt dort nur .custom-option__inner), das Feld heisst aber gleich.
  // Ausgenommen: Versanddatum der Geschenkkarte (Shopify-Feld «Send on»).
  var SELECTOR = 'input[type="date"][name^="properties["]:not([name="properties[Send on]"])';
  var BLOCK = '.custom-option, .custom-option__inner';

  var TEXTE = {
    tage: 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag',
    tage_kurz: 'So,Mo,Di,Mi,Do,Fr,Sa',
    monate: 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    wochenkopf: 'Mo,Di,Mi,Do,Fr,Sa,So',
    tag_datum: '%WOCHENTAG%, %DATUM%',
    kalender_tag: '%WOCHENTAG%, %TAG%. %MONAT% %JAHR%',
    vorheriger_monat: 'Vorheriger Monat',
    naechster_monat: 'Nächster Monat',
    frei: 'frei',
    ausgebucht: 'ausgebucht',
    nicht_waehlbar: 'nicht wählbar',
    kein_platz: 'nicht genug Platz für %ANZAHL% Federelemente',
    laden: 'Freie Termine werden geladen …',
    dein_termin: 'Dein Termin:',
    termin_waehlen: 'Bitte wähle deinen Einsende-Termin im Kalender.',
    naechster_frei: 'Nächster freier Termin: %DATUM%',
    kein_termin_menge: 'Für %ANZAHL% Federelemente am gleichen Tag ist zurzeit kein Termin frei – bitte melde dich bei uns.',
    alle_ausgebucht: 'Zurzeit sind alle Termine ausgebucht – bitte melde dich bei uns.',
    fruehestens: 'Bitte wähle frühestens den %DATUM%.',
    spaetestens: 'Bitte wähle spätestens den %DATUM%.',
    sonntag_zu: 'Sonntags sind wir geschlossen – bitte wähle einen anderen Tag.',
    kein_annahmetag: '%WOCHENTAG%s vergeben wir keine Werkstatt-Termine – bitte wähle einen anderen Tag.',
    tag_ausgebucht: 'Dieser Tag ist leider schon ausgebucht.',
    zu_wenig_platz: 'An diesem Tag ist nicht mehr genug Platz für %ANZAHL% Federelemente – bitte wähle einen anderen Tag oder eine kleinere Menge.',
    datum_lang: '%WOCHENTAG%, %TAG%. %MONAT%',
    naechster_service: 'Nächster freier Service-Termin: %DATUM%',
    termin_waehlen_link: 'Termin wählen'
  };
  var seite = (window.mrsTexte && window.mrsTexte.termin) || {};
  for (var name in TEXTE) {
    if (seite[name]) TEXTE[name] = seite[name];
  }
  // ersetzt %NAME% durch werte.NAME
  function tx(schluessel, werte) {
    var s = TEXTE[schluessel];
    for (var w in werte) s = s.split('%' + w + '%').join(werte[w]);
    return s;
  }
  var TAGE = TEXTE.tage.split(',');
  var TAGE_KURZ = TEXTE.tage_kurz.split(',');
  var MONATE = TEXTE.monate.split(',');
  var WOCHENKOPF = TEXTE.wochenkopf.split(',');

  var belegung = { status: 'leer', frei: null, zeit: 0 };

  // Belegung im Browser merken (5 Minuten), damit nicht jeder Seitenaufruf den Kalender abfragt
  var SPEICHER = 'mrsBelegung';
  (function ausSpeicher() {
    try {
      var s = JSON.parse(window.sessionStorage.getItem(SPEICHER) || 'null');
      if (s && s.frei && typeof s.zeit === 'number' && Date.now() - s.zeit < BELEGUNG_MAX_ALTER) {
        belegung.frei = s.frei;
        belegung.status = 'ok';
        belegung.zeit = s.zeit;
      }
    } catch (e) { /* kein Speicher (z. B. privates Fenster) – dann wird normal geladen */ }
  })();
  function inSpeicher() {
    try {
      window.sessionStorage.setItem(SPEICHER, JSON.stringify({ zeit: belegung.zeit, frei: belegung.frei }));
    } catch (e) { /* egal */ }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function nice(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function niceTag(d) { return tx('tag_datum', { WOCHENTAG: TAGE_KURZ[d.getDay()], DATUM: nice(d) }); }
  function parse(v) {
    var p = String(v || '').split('-').map(Number);
    if (p.length !== 3 || !p[0] || !p[1] || !p[2]) return null;
    return new Date(p[0], p[1] - 1, p[2]);
  }
  function plus(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }

  function feldName(input) {
    var m = /^properties\[(.*)\]$/.exec(input.getAttribute('name') || '');
    if (!m) return '';
    var t = document.createElement('textarea');
    t.innerHTML = m[1];
    return t.value;
  }

  function konfig(input) { return FELDER[feldName(input)] || STANDARD; }

  function bounds(input) {
    return grenzen(konfig(input), input.getAttribute('data-exclude-sunday') === 'true');
  }

  function grenzen(cfg, ohneSonntag) {
    var ohne = (cfg.ohneTage || []).slice();
    if (ohneSonntag && ohne.indexOf(0) < 0) ohne.push(0);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var min = plus(today, cfg.vorlauf || 0);
    for (var i = 0; i < 7 && ohne.indexOf(min.getDay()) >= 0; i++) min = plus(min, 1);
    var max = cfg.maxTage > 0 ? plus(today, cfg.maxTage) : null;
    return { cfg: cfg, min: min, max: max, ohne: ohne };
  }

  /* ---------- Belegung aus dem Werkstatt-Kalender ---------- */

  function nutztBelegung(cfg) {
    return !!cfg.belegung && BELEGUNG_URL.indexOf('https://') === 0;
  }

  function belegungBereit() {
    return belegung.status === 'ok' && belegung.frei;
  }

  function ladeBelegung() {
    if (belegung.status === 'laden') return;
    if (belegung.status === 'ok' && Date.now() - belegung.zeit < BELEGUNG_MAX_ALTER) return;
    if (belegung.status === 'fehler' && Date.now() - belegung.zeit < BELEGUNG_MAX_ALTER) return;
    if (!window.fetch) { belegung.status = 'fehler'; belegung.zeit = Date.now(); return; }
    belegung.status = 'laden';
    var fertig = false;
    var timer = setTimeout(function () {
      if (fertig) return;
      fertig = true;
      belegung.status = 'fehler';
      belegung.zeit = Date.now();
    }, BELEGUNG_TIMEOUT);
    window.fetch(BELEGUNG_URL, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (fertig) return;
        fertig = true;
        clearTimeout(timer);
        if (!data || !data.ok || !data.frei) throw new Error('keine Belegung');
        belegung.frei = data.frei;
        belegung.status = 'ok';
        belegung.zeit = Date.now();
        inSpeicher();
        alleAktualisieren();
      })
      .catch(function () {
        if (!fertig) { fertig = true; clearTimeout(timer); }
        // Ohne Belegung gelten nur die Wochentag-Regeln – buchen bleibt möglich.
        if (belegung.status === 'laden') { belegung.status = 'fehler'; belegung.zeit = Date.now(); }
      });
  }

  /** Freie Plätze an einem Tag; null = unbekannt */
  function freiAm(d) {
    if (!belegungBereit()) return null;
    var f = belegung.frei[iso(d)];
    return typeof f === 'number' ? f : null;
  }

  function menge(input) {
    var fid = input.getAttribute('form');
    var form = fid ? document.getElementById(fid) : null;
    var q = form && form.elements ? form.elements.namedItem('quantity') : null;
    if (q && !('value' in q) && q.length) q = q[0];
    var n = parseInt(q && q.value, 10);
    return n > 0 ? n : 1;
  }

  /** Erster Tag ab «min», an dem noch genug Platz ist. undefined = keine Belegung bekannt, null = nichts frei */
  function naechsterFrei(input, b) {
    return naechsterFreiFuer(b, menge(input));
  }

  /** wie naechsterFrei, aber für eine feste Anzahl Federelemente (Anzeige) */
  function naechsterFreiFuer(b, n) {
    if (!nutztBelegung(b.cfg) || !belegungBereit()) return undefined;
    var ende = b.max || plus(b.min, 120);
    for (var d = new Date(b.min); d <= ende; d = plus(d, 1)) {
      if (b.ohne.indexOf(d.getDay()) >= 0) continue;
      var f = freiAm(d);
      if (f === null) return undefined;
      if (f >= n) return d;
    }
    return null;
  }

  function hinweis(input, text) {
    var p = input._mtbHinweis;
    if (!p) {
      if (!text) return;
      p = document.createElement('p');
      p.className = 'text-caption mtb-termin-frei';
      p.style.marginTop = '4px';
      p.style.fontWeight = '600';
      p.setAttribute('aria-live', 'polite');
      var nach = input._mtbKalender ? input._mtbKalender.box : input;
      nach.parentNode.insertBefore(p, nach.nextSibling);
      input._mtbHinweis = p;
    }
    p.textContent = text;
    p.hidden = !text;
  }

  /* ---------- Eigener Monatskalender ---------- */

  var STIL = '' +
    '.mtb-dk-nativ{position:absolute!important;left:0;top:0;width:1px!important;height:1px!important;min-height:0!important;padding:0!important;margin:0!important;border:0!important;opacity:0;pointer-events:none;overflow:hidden}' +
    '.mtb-dk{max-width:420px;box-sizing:border-box;border:1px solid #cfd4db;border-radius:14px;padding:12px;background:#fff;color:#111318;margin-top:2px}' +
    '.mtb-dk--fehler{border-color:#d71920;box-shadow:0 0 0 3px rgba(215,25,32,.15)}' +
    '.mtb-dk-kopf{display:flex;align-items:center;justify-content:space-between;margin:0 0 8px}' +
    '.mtb-dk-monat{font-weight:700;font-size:15px}' +
    '.mtb-dk-nav{width:36px;height:36px;padding:0;border:1px solid #dfe3e8;border-radius:50%;background:#fff;color:#111318;font:inherit;font-size:20px;line-height:1;cursor:pointer}' +
    '.mtb-dk-nav:hover:not(:disabled){border-color:#111318}' +
    '.mtb-dk-nav:disabled{opacity:.3;cursor:default}' +
    '.mtb-dk-raster{display:grid;grid-template-columns:repeat(7,1fr);gap:4px}' +
    '.mtb-dk-wt{font-size:12px;font-weight:600;color:#68707d;text-align:center;padding:2px 0}' +
    '.mtb-dk-tag{height:42px;min-width:0;margin:0;padding:0;border:1px solid #cfd4db;border-radius:9px;background:#fff;color:#111318;font:inherit;font-size:15px;font-weight:600;line-height:1.1;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;text-decoration:none}' +
    '.mtb-dk-tag:hover:not(:disabled){border-color:#111318;box-shadow:0 0 0 1px #111318}' +
    '.mtb-dk-tag:focus-visible{outline:2px solid #d71920;outline-offset:2px}' +
    '.mtb-dk-tag--zu{background:#eef0f2;border-color:#eef0f2;color:#9aa1ab;font-weight:500;text-decoration:line-through;cursor:not-allowed}' +
    '.mtb-dk-tag--aus{background:transparent;border-color:transparent;color:#c4c9cf;font-weight:400;cursor:default}' +
    '.mtb-dk-tag--gewaehlt,.mtb-dk-tag--gewaehlt:hover:not(:disabled){background:#d71920;border-color:#d71920;color:#fff;box-shadow:none}' +
    '.mtb-dk-legende{display:flex;align-items:center;flex-wrap:wrap;gap:4px 14px;font-size:12px;color:#68707d;margin:10px 0 0}' +
    '.mtb-dk-legende span{display:inline-flex;align-items:center;gap:6px}' +
    '.mtb-dk-legende i{display:inline-block;width:14px;height:14px;box-sizing:border-box;border:1px solid #cfd4db;border-radius:4px;background:#fff}' +
    '.mtb-dk-legende i.zu{border-color:#eef0f2;background:linear-gradient(to top right,#eef0f2 45%,#9aa1ab 46%,#9aa1ab 54%,#eef0f2 55%)}' +
    '.mtb-dk-meldung{font-size:13px;line-height:1.4;margin:8px 0 0;color:#111318}' +
    '.mtb-dk-meldung--fehler{color:#b3141b;font-weight:600}' +
    '.mtb-dk-laden{font-size:12px;color:#68707d;margin:6px 0 0}' +
    '@media (max-width:400px){.mtb-dk{padding:10px}.mtb-dk-tag{height:38px;font-size:14px}.mtb-dk-raster{gap:3px}}';

  function stilEinfuegen() {
    if (document.getElementById('mtb-dk-stil')) return;
    var st = document.createElement('style');
    st.id = 'mtb-dk-stil';
    st.textContent = STIL;
    (document.head || document.documentElement).appendChild(st);
  }

  /** Kann der Tag gewählt werden? → { ok, grund, aus } */
  function tagStatus(b, d, n) {
    if (d < b.min || (b.max && d > b.max)) return { ok: false, aus: true, grund: tx('nicht_waehlbar') };
    if (b.ohne.indexOf(d.getDay()) >= 0) return { ok: false, grund: tx('ausgebucht') }; // Kunde sieht nur «ausgebucht»
    var f = nutztBelegung(b.cfg) ? freiAm(d) : null;
    if (f !== null && f <= 0) return { ok: false, grund: tx('ausgebucht') };
    if (f !== null && n > f) return { ok: false, grund: tx('kein_platz', { ANZAHL: n }) };
    return { ok: true };
  }

  function kalenderBauen(input) {
    if (input._mtbKalender) return input._mtbKalender;
    stilEinfuegen();
    var box = document.createElement('div');
    box.className = 'mtb-dk';
    input.parentNode.insertBefore(box, input.nextSibling);
    input.classList.add('mtb-dk-nativ');
    input.setAttribute('tabindex', '-1');
    input.setAttribute('aria-hidden', 'true');
    var eltern = input.parentNode;
    if (window.getComputedStyle && window.getComputedStyle(eltern).position === 'static') eltern.style.position = 'relative';
    var k = { box: box, monat: null, fehler: false };
    input._mtbKalender = k;
    box.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!t || !box.contains(t) || t.disabled) return;
      var nav = t.getAttribute('data-nav');
      if (nav) {
        k.monat = new Date(k.monat.getFullYear(), k.monat.getMonth() + Number(nav), 1);
        zeichnen(input);
        var gleich = box.querySelector('[data-nav="' + nav + '"]');
        if (gleich && !gleich.disabled) gleich.focus();
        return;
      }
      var tag = t.getAttribute('data-tag');
      if (!tag) return;
      k.fehler = false;
      input.value = tag;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      zeichnen(input);
      var neu = box.querySelector('[data-tag="' + tag + '"]');
      if (neu) neu.focus();
    });
    return k;
  }

  function zeichnen(input) {
    var k = input._mtbKalender;
    if (!k) return;
    var b = bounds(input);
    var n = menge(input);
    var gewaehlt = parse(input.value);
    var ersterMonat = new Date(b.min.getFullYear(), b.min.getMonth(), 1);
    var letzterMonat = b.max ? new Date(b.max.getFullYear(), b.max.getMonth(), 1) : null;
    if (!k.monat) {
      var nf = naechsterFrei(input, b);
      var start = gewaehlt || nf || b.min;
      k.monat = new Date(start.getFullYear(), start.getMonth(), 1);
    }
    if (k.monat < ersterMonat) k.monat = ersterMonat;
    if (letzterMonat && k.monat > letzterMonat) k.monat = letzterMonat;
    var y = k.monat.getFullYear(), m = k.monat.getMonth();
    var h = [];
    h.push('<div class="mtb-dk-kopf">');
    h.push('<button type="button" class="mtb-dk-nav" data-nav="-1" aria-label="' + tx('vorheriger_monat') + '"' + (k.monat <= ersterMonat ? ' disabled' : '') + '>&#8249;</button>');
    h.push('<span class="mtb-dk-monat" aria-live="polite">' + MONATE[m] + ' ' + y + '</span>');
    h.push('<button type="button" class="mtb-dk-nav" data-nav="1" aria-label="' + tx('naechster_monat') + '"' + (letzterMonat && k.monat >= letzterMonat ? ' disabled' : '') + '>&#8250;</button>');
    h.push('</div><div class="mtb-dk-raster">');
    WOCHENKOPF.forEach(function (w) { h.push('<span class="mtb-dk-wt" aria-hidden="true">' + w + '</span>'); });
    var leer = (new Date(y, m, 1).getDay() + 6) % 7;
    for (var i = 0; i < leer; i++) h.push('<span></span>');
    var anzahl = new Date(y, m + 1, 0).getDate();
    for (var t = 1; t <= anzahl; t++) {
      var d = new Date(y, m, t);
      var st = tagStatus(b, d, n);
      var sel = !!gewaehlt && iso(gewaehlt) === iso(d);
      var info = st.ok ? tx('frei') : st.grund;
      var cls = 'mtb-dk-tag' + (st.ok ? '' : (st.aus ? ' mtb-dk-tag--aus' : ' mtb-dk-tag--zu')) + (sel ? ' mtb-dk-tag--gewaehlt' : '');
      h.push('<button type="button" class="' + cls + '" data-tag="' + iso(d) + '"' + (st.ok ? '' : ' disabled') +
        (sel ? ' aria-pressed="true"' : '') + ' title="' + info + '" aria-label="' + tx('kalender_tag', { WOCHENTAG: TAGE[d.getDay()], TAG: t, MONAT: MONATE[m], JAHR: y }) + ', ' + info + '">' +
        t + '</button>');
    }
    h.push('</div>');
    h.push('<p class="mtb-dk-legende"><span><i></i>' + tx('frei') + '</span><span><i class="zu"></i>' + tx('ausgebucht') + '</span></p>');
    if (nutztBelegung(b.cfg) && belegung.status === 'laden') h.push('<p class="mtb-dk-laden">' + tx('laden') + '</p>');
    if (gewaehlt) {
      var msg = input.validationMessage;
      h.push(msg ? '<p class="mtb-dk-meldung mtb-dk-meldung--fehler" role="alert">' + msg + '</p>'
        : '<p class="mtb-dk-meldung">' + tx('dein_termin') + ' <strong>' + niceTag(gewaehlt) + '</strong></p>');
    } else if (k.fehler) {
      h.push('<p class="mtb-dk-meldung mtb-dk-meldung--fehler" role="alert">' + tx('termin_waehlen') + '</p>');
    }
    k.box.innerHTML = h.join('');
    k.box.classList.toggle('mtb-dk--fehler', !!(k.fehler && !gewaehlt) || !!(gewaehlt && input.validationMessage));
  }

  /* ---------- Tuning: Feld nur bei Varianten mit Werkstatt-Arbeit ---------- */

  /** ID der gewählten Variante im zugehörigen Produktformular ('' = unbekannt) */
  function varianteVon(input) {
    var fid = input.getAttribute('form');
    var form = fid ? document.getElementById(fid) : null;
    var el = form && form.elements ? form.elements.namedItem('id') : null;
    if (el && !('value' in el) && el.length) el = el[0];
    return el && el.value ? String(el.value) : '';
  }

  /** Blendet das Feld je nach Variante ein/aus. true = Feld wird gebraucht */
  function sichtbarkeit(input) {
    var liste = input.getAttribute('data-werkstatt-varianten');
    if (liste === null) return true;
    var vid = varianteVon(input);
    var aktiv;
    if (liste === 'alle') {
      aktiv = true;
    } else if (liste.indexOf('ohne:') === 0) {
      // Ausnahmen-Liste: nur diese Varianten brauchen keinen Termin
      aktiv = !vid || (',' + liste.slice(5) + ',').indexOf(',' + vid + ',') < 0;
    } else {
      aktiv = !vid || (',' + liste + ',').indexOf(',' + vid + ',') >= 0;
    }
    var block = input.closest ? input.closest(BLOCK) : null;
    if (block) block.hidden = !aktiv;
    input.disabled = !aktiv;
    if (!aktiv) input.setCustomValidity('');
    return aktiv;
  }

  function alleSichtbarkeit() {
    var inputs = document.querySelectorAll(SELECTOR + '[data-werkstatt-varianten]');
    for (var i = 0; i < inputs.length; i++) apply(inputs[i]);
    anzeigen();
  }

  // Der Variantenwechsel lädt Teile der Seite nach – deshalb mehrmals kurz danach prüfen
  function sichtbarkeitSpaeter() {
    alleSichtbarkeit();
    setTimeout(alleSichtbarkeit, 150);
    setTimeout(alleSichtbarkeit, 600);
    setTimeout(alleSichtbarkeit, 1500);
  }

  /* ---------- Anzeige «Nächster freier Service-Termin» ---------- */

  var ANZEIGE = '[data-mrs-naechster-termin]';
  var TERMIN_FELD = 'input[name="properties[Einsende-Termin]"]';

  var ANZEIGE_STIL = '' +
    '.mrs-nt{display:flex;align-items:center;flex-wrap:wrap;gap:4px 8px;margin:12px 0 0;font-size:14px;line-height:1.4}' +
    '.mrs-nt[hidden]{display:none}' +
    '.mrs-nt__punkt{flex:0 0 auto;width:9px;height:9px;border-radius:50%;background:#1f9d55;box-shadow:0 0 0 3px rgba(31,157,85,.2)}' +
    '.mrs-nt__text{font-weight:600}' +
    '.mrs-nt__link{color:inherit;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}' +
    '.mrs-nt__link:hover{text-decoration-thickness:2px}' +
    '.mrs-nt--seite{display:block;text-align:center;margin:20px auto 24px;font-size:14px;line-height:1.35}' +
    '.mrs-nt--seite .mrs-nt__punkt{display:inline-block;vertical-align:middle;position:relative;top:-1px;margin:0 9px 0 3px;background:#3ccf73;box-shadow:0 0 0 3px rgba(60,207,115,.25)}' +
    '.mrs-nt--seite .mrs-nt__text{font-weight:400}' +
    '.mrs-nt__label{opacity:.85}' +
    '.mrs-nt__datum{display:block;margin-top:3px;font-size:1.35em;font-weight:700;white-space:nowrap}' +
    '.mrs-nt--links{justify-content:flex-start;text-align:left;margin-left:0}';

  function anzeigeStil() {
    if (document.getElementById('mrs-nt-stil')) return;
    var st = document.createElement('style');
    st.id = 'mrs-nt-stil';
    st.textContent = ANZEIGE_STIL;
    (document.head || document.documentElement).appendChild(st);
  }

  /** «Freitag, 16. Oktober» (kurz: «Fr, 16. Oktober») */
  function datumLang(d, kurz) {
    return tx('datum_lang', { WOCHENTAG: (kurz ? TAGE_KURZ : TAGE)[d.getDay()], TAG: d.getDate(), MONAT: MONATE[d.getMonth()] });
  }

  /** Seite: oben «Nächster freier Service-Termin» (mit Punkt davor), darunter das Datum in einer eigenen Zeile.
   *  Steht im übersetzten Text etwas nach %DATUM% (andere Satzstellung), bleibt es einzeilig. */
  function zweizeilig(text, datum) {
    var teile = TEXTE.naechster_service.split('%DATUM%');
    if (teile.length !== 2 || teile[1].replace(/\s+/g, '') !== '') {
      text.textContent = tx('naechster_service', { DATUM: datum });
      return;
    }
    var label = document.createElement('span');
    label.className = 'mrs-nt__label';
    label.textContent = teile[0].replace(/[\s:\u00a0\u202f]+$/, '');
    var tag = document.createElement('span');
    tag.className = 'mrs-nt__datum';
    tag.textContent = datum;
    text.textContent = '';
    text.appendChild(label);
    text.appendChild(tag);
  }

  /** Feld «Einsende-Termin» im Produktformular, zu dem die Anzeige gehört */
  function terminFeldZu(el) {
    var fid = el.getAttribute('data-form');
    if (!fid) return null;
    var bereich = (el.closest && el.closest('.js-product')) || document; // Produktseite oder Schnellkauf-Fenster
    var felder = bereich.querySelectorAll(TERMIN_FELD);
    for (var i = 0; i < felder.length; i++) {
      if (felder[i].getAttribute('form') === fid) return felder[i];
    }
    return null;
  }

  /** Zeile unter dem Preis einbauen, wenn das Produkt ein Feld «Einsende-Termin» hat (Produktseite, Schnellkauf) */
  function produktZeilen() {
    var felder = document.querySelectorAll(TERMIN_FELD);
    for (var i = 0; i < felder.length; i++) {
      var fid = felder[i].getAttribute('form');
      var produkt = felder[i].closest ? felder[i].closest('.js-product') : null;
      var preis = produkt ? produkt.querySelector('.product-price') : null;
      if (!fid || !preis || preis.querySelector(ANZEIGE)) continue;
      var p = document.createElement('p');
      p.className = 'mrs-nt mrs-nt--produkt';
      p.setAttribute('data-mrs-naechster-termin', 'produkt');
      p.setAttribute('data-form', fid);
      p.setAttribute('aria-live', 'polite');
      p.hidden = true;
      p.innerHTML = '<span class="mrs-nt__punkt" aria-hidden="true"></span><span class="mrs-nt__text" data-mrs-nt-text></span>' +
        '<a href="#" class="mrs-nt__link" data-mrs-nt-link></a>';
      p.querySelector('[data-mrs-nt-link]').textContent = tx('termin_waehlen_link');
      preis.appendChild(p);
    }
  }

  function anzeigen() {
    produktZeilen();
    var els = document.querySelectorAll(ANZEIGE);
    if (!els.length) return;
    var cfg = FELDER['Einsende-Termin'];
    if (!nutztBelegung(cfg)) return;
    anzeigeStil();
    ladeBelegung(); // lädt nur, wenn nichts da oder älter als 5 Minuten; danach ruft alleAktualisieren() diese Funktion nochmals auf
    var nf = naechsterFreiFuer(grenzen(cfg, true), 1);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var art = el.getAttribute('data-mrs-naechster-termin');
      var text = el.querySelector('[data-mrs-nt-text]') || el;
      if (art === 'produkt') {
        var feld = terminFeldZu(el);
        if (!feld || feld.disabled) { el.hidden = true; continue; }
      }
      if (nf instanceof Date) {
        if (art === 'seite') zweizeilig(text, datumLang(nf, false));
        else text.textContent = tx('naechster_service', { DATUM: datumLang(nf, art === 'leiste') });
        el.hidden = false;
      } else if (art !== 'leiste') {
        el.hidden = true; // keine Belegung oder alles ausgebucht: lieber nichts als etwas Falsches
      }
    }
  }

  // «Termin wählen»: zum Kalender scrollen (wählt bewusst keinen Tag vor)
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mrs-nt-link]') : null;
    if (!a) return;
    var el = a.closest(ANZEIGE);
    var feld = el ? terminFeldZu(el) : null;
    if (!feld || feld.disabled) return;
    e.preventDefault();
    var ziel = (feld._mtbKalender && feld._mtbKalender.box) || (feld.closest ? feld.closest(BLOCK) : null) || feld;
    var glatt = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (ziel.scrollIntoView) ziel.scrollIntoView({ behavior: glatt ? 'smooth' : 'auto', block: 'center' });
    if (feld._mtbKalender) {
      ziel.setAttribute('tabindex', '-1');
      try { ziel.focus({ preventScroll: true }); } catch (err) { ziel.focus(); }
    }
  });

  /* ---------- Feld vorbereiten und prüfen ---------- */

  function apply(input) {
    if (!sichtbarkeit(input)) return;
    var b = bounds(input);
    if (nutztBelegung(b.cfg)) ladeBelegung();
    if (b.cfg.kalender) kalenderBauen(input);
    var nf = naechsterFrei(input, b);
    input.min = iso(nf || b.min);
    if (b.max) input.max = iso(b.max); else input.removeAttribute('max');
    if (b.cfg.kalender && input.value) hinweis(input, ''); // gewählter Tag steht schon im Kalender
    else if (nf) hinweis(input, tx('naechster_frei', { DATUM: niceTag(nf) }));
    else if (nf === null) {
      var n = menge(input);
      hinweis(input, n > 1 ? tx('kein_termin_menge', { ANZAHL: n }) : tx('alle_ausgebucht'));
    }
    else hinweis(input, '');
    if (b.cfg.kalender) zeichnen(input);
  }

  function validate(input) {
    if (input.disabled) { input.setCustomValidity(''); return ''; }
    var b = bounds(input);
    var d = parse(input.value);
    var msg = '';
    if (d) {
      if (d < b.min) {
        msg = tx('fruehestens', { DATUM: nice(b.min) });
      } else if (b.max && d > b.max) {
        msg = tx('spaetestens', { DATUM: nice(b.max) });
      } else if (b.ohne.indexOf(d.getDay()) >= 0) {
        msg = d.getDay() === 0 ? tx('sonntag_zu') : tx('kein_annahmetag', { WOCHENTAG: TAGE[d.getDay()] });
      } else if (nutztBelegung(b.cfg)) {
        var f = freiAm(d);
        if (f !== null) {
          var n = menge(input);
          var nf = naechsterFrei(input, b);
          var weiter = nf ? ' ' + tx('naechster_frei', { DATUM: niceTag(nf) }) + '.' : '';
          if (f <= 0) {
            msg = tx('tag_ausgebucht') + weiter;
          } else if (n > f) {
            msg = tx('zu_wenig_platz', { ANZAHL: n }) + weiter;
          }
        }
      }
    }
    input.setCustomValidity(msg);
    if (b.cfg.kalender) zeichnen(input);
    return msg;
  }

  function initAll(root) {
    var inputs = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      apply(inputs[i]);
      if (inputs[i].value) validate(inputs[i]);
    }
  }

  function alleAktualisieren() { initAll(document); anzeigen(); }

  function matches(el) {
    return el && el.nodeType === 1 && el.matches && el.matches(SELECTOR);
  }

  // form.id geht nicht: das Produktformular hat ein Feld namens «id» (Variante), das die Eigenschaft überdeckt
  function formularId(form) {
    return form && form.getAttribute ? form.getAttribute('id') || '' : '';
  }

  function felderZumFormular(formId) {
    return formId ? document.querySelectorAll(SELECTOR + '[form="' + formId + '"]') : [];
  }

  document.addEventListener('focusin', function (e) {
    if (matches(e.target)) apply(e.target);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (matches(t)) {
      apply(t);
      if (validate(t)) t.reportValidity();
      return;
    }
    // Variante gewechselt → Feld ein-/ausblenden (Tuning)
    if (t && t.classList && t.classList.contains('js-option')) {
      sichtbarkeitSpaeter();
      return;
    }
    // Menge geändert → Datum nochmals prüfen
    if (t && t.name === 'quantity' && t.form) {
      var inputs = felderZumFormular(formularId(t.form));
      for (var i = 0; i < inputs.length; i++) {
        apply(inputs[i]);
        if (inputs[i].value) validate(inputs[i]);
      }
    }
  });

  document.addEventListener('on:variant:change', sichtbarkeitSpaeter);

  // Vor dem Absenden nochmals prüfen (z. B. wenn der Browser ein altes Datum vorausgefüllt hat)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="add"], button[type="submit"]') : null;
    var fid = btn && btn.form ? formularId(btn.form) : '';
    if (!fid) return;
    var inputs = felderZumFormular(fid);
    for (var i = 0; i < inputs.length; i++) {
      apply(inputs[i]);
      var k = inputs[i]._mtbKalender;
      if (k && !inputs[i].disabled && inputs[i].required && !inputs[i].value) k.fehler = true;
      validate(inputs[i]);
    }
  }, true);

  // Schnellkauf-Fenster: Inhalt wird nachgeladen – neue Felder ebenfalls vorbereiten
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var varianteNeu = false;
      var anzeigeNeu = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (matches(n)) apply(n);
          else if (n.querySelector && n.querySelector(SELECTOR)) initAll(n);
          if ((n.matches && n.matches('input[name="id"]')) || (n.querySelector && n.querySelector('input[name="id"]'))) varianteNeu = true;
          if ((n.matches && n.matches(ANZEIGE)) || (n.querySelector && n.querySelector(ANZEIGE))) anzeigeNeu = true;
        }
      }
      if (varianteNeu) alleSichtbarkeit();
      else if (anzeigeNeu) anzeigen();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); anzeigen(); });
  } else {
    initAll();
    anzeigen();
  }
})();
